import { render, staticRenderFns } from "./VideoCallMetadataForm.vue?vue&type=template&id=c054d974&scoped=true&"
import script from "./VideoCallMetadataForm.vue?vue&type=script&lang=js&"
export * from "./VideoCallMetadataForm.vue?vue&type=script&lang=js&"
import style0 from "./VideoCallMetadataForm.vue?vue&type=style&index=0&id=c054d974&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c054d974",
  null
  
)

export default component.exports